<script>
  import Counter2 from "../../../Publish/BulkUpload/Shared/counter2.svelte"

  //export count about documents
  export let count = {}
</script>

<div>
  <div class="mt-3 flex flex-col items-center gap-3 lg:flex-row">
    <div class="w-full lg:w-1/3">
      <Counter2 count={count.view || 0} icon={"fa-solid fa-eye"} titleText={"VIEWED"} color={"#ff6a00"} gradient={"#f8a500, #ff6a00"} />
    </div>
    <div class="w-full lg:w-1/3">
      <Counter2 count={count.verify || 0} icon={"fa-solid fa-circle-check"} titleText={"VERIFIED"} color={"#00D515"} gradient={"#58FE69, #00D515"} />
    </div>
    <div class="w-full lg:w-1/3">
      <Counter2 count={count.download || 0} icon={"fa-solid fa-circle-down"} titleText={"DOWNLOADED"} color={"#00B2FF"} gradient={"#A3E3FF, #00B2FF"} />
    </div>
  </div>
</div>
